import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import styles from "../blocks/blocks.module.scss";

export function ColumnBreakNodeView({ node, selected }: NodeViewProps) {
  return (
    <NodeViewWrapper data-type="column-break-block" data-block-id={node.attrs.blockId} className={selected ? "ProseMirror-selectednode" : ""}>
      <div className={styles.columnBreakBlock}>
        <div className={styles.columnBreakLine}>
          <span className={styles.columnBreakLabel}>Column Break</span>
        </div>
      </div>
    </NodeViewWrapper>
  );
}
